import axios from 'axios';

async function ObtenerPaises() {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_paises"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!"
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerPaises;